/* eslint-disable max-lines-per-function */
import { ReactElement } from 'react';

import { AppointmentAdvancePayment } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { StyledFlex, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import { AdvancePaymentStatusIcon } from '~libs.desktop.shared.appointment-advance-payment';

import { AppointmentDetailsInfoItem } from '../AppointmentDetailsInfoItem';
import { calendarTranslationKeys } from '../../../../../../translations';

import { isAppointmentAdvancePaymentAvailable } from './AppointmentAdvancePaymentInfoItem.utils';
import {
   StyledAdvancePaymentStatusText,
   StyledPaidAmountText,
   StyledRequiredAmountText,
} from './AppointmentAdvancePaymentInfoItem.styled';

const t = calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab.advancePayments;

type AppointmentAdvancePaymentInfoItemProps = {
   readonly appointmentAdvancePayment: AppointmentAdvancePayment | null;
   readonly onlinePaymentsIntegrationExists: boolean;
};

export const AppointmentAdvancePaymentInfoItem = (
   props: AppointmentAdvancePaymentInfoItemProps
): ReactElement | null => {
   const translate = useTranslate();

   const appointmentAdvancePaymentAvailable = isAppointmentAdvancePaymentAvailable(
      props.appointmentAdvancePayment,
      props.onlinePaymentsIntegrationExists
   );

   if (!appointmentAdvancePaymentAvailable || !props.appointmentAdvancePayment) {
      return null;
   }

   return (
      <AppointmentDetailsInfoItem
         testId={'appointmentAdvancePayment'}
         icon={
            <AdvancePaymentStatusIcon
               paidAmount={props.appointmentAdvancePayment.paidAmount}
               requiredAmount={props.appointmentAdvancePayment.requiredAmount}
            />
         }
         content={
            <StyledFlex gap={'4px'}>
               <Text testId={'advancePayment'}>{translate(t.advancePayment)}</Text>
               <StyledAdvancePaymentStatusText
                  paidAmount={props.appointmentAdvancePayment.paidAmount}
                  requiredAmount={props.appointmentAdvancePayment.requiredAmount}
               />
            </StyledFlex>
         }
         rightContent={
            <TextSeparator separator={TextSeparatorType.SPACE_SLASH_SPACE}>
               <StyledPaidAmountText
                  testId={'advancePaymentPaidAmount'}
                  value={props.appointmentAdvancePayment.paidAmount.asNumber()}
                  stripDecimalZeroes
                  hideCurrency
               />
               <StyledRequiredAmountText
                  testId={'advancePaymentRequiredAmount'}
                  value={props.appointmentAdvancePayment.requiredAmount.asNumber()}
                  stripDecimalZeroes
               />
            </TextSeparator>
         }
      />
   );
};
